import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined'
import { IconButton, Tooltip, MenuItem, Typography, ListItemText, ListItemIcon } from '@mui/material'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { Nullish } from '@omnea-app/packages/universal/utility-types/utilityTypes'

interface Props {
  id: Nullish<string>
  entityTypeLabel?: string
  color?: string
  inDropdown?: boolean
  inDropdownWithIcon?: boolean
}

export const CopyIdButton: React.FC<Props> = ({
  id,
  entityTypeLabel = '',
  color,
  inDropdown = false,
  inDropdownWithIcon = false,
}) => {
  const { user } = useAuthenticatedUser()
  const title = `Copy ${entityTypeLabel} UUID`

  if (!user.isOmnean) return null
  if (!id) return null

  const handleClick = async () => {
    await navigator.clipboard.writeText(id)
  }

  if (inDropdown) {
    return (
      <MenuItem onClick={() => handleClick()}>
        <Typography>{title}</Typography>
      </MenuItem>
    )
  }

  if (inDropdownWithIcon) {
    return (
      <MenuItem onClick={() => handleClick()}>
        <ListItemIcon>
          <IntegrationInstructionsOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary={title} />
      </MenuItem>
    )
  }

  return (
    <Tooltip title={title}>
      <IconButton onClick={() => handleClick()} sx={{ color: color ?? 'neutralDark.0' }}>
        <IntegrationInstructionsOutlinedIcon />
      </IconButton>
    </Tooltip>
  )
}
